import { render, staticRenderFns } from "./QuestionOptionsForm.vue?vue&type=template&id=5a6bcc7d&lang=pug"
import script from "./QuestionOptionsForm.vue?vue&type=script&lang=js"
export * from "./QuestionOptionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports